import { Card, Container } from 'geniebook-ui/dist';
import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { userDetailQueryAtom } from '@atom/globalQueryAtom';

const changelog = require('../../assets/changelog.json');

interface LogInterface {
  test_id: string;
  notes: string;
}

interface ChangelogInterface {
  date: string;
  log: Array<LogInterface>;
}

const JOHN_LEE_USER_ID = '4406';

const ChangeLog = () => {
  const navigate = useNavigate();
  const [canSeeLog, setCanSeeLog] = useState(false);
  const [open, setOpen] = React.useState(false);

  const userDetail = useAtomValue(userDetailQueryAtom);
  useEffect(() => {
    if (!userDetail.isLoading && userDetail?.data) {
      if (userDetail?.data.error) navigate('/');
      if (userDetail?.data?.data) {
        if (userDetail.data.data.user_id != JOHN_LEE_USER_ID) navigate('/');
        else setCanSeeLog(true);
      } else {
        navigate('/');
      }
    }
  }, [userDetail?.data]);

  const LogCard = (date: string, log: LogInterface[]) => {
    return (
      <Card
        key={date}
        className="mt-4 cursor-pointer"
        body={
          <div onClick={() => setOpen(!open)}>
            <div className="text-lg font-medium">{date}</div>
            {!open && (
              <div className="text-sm text-neutral-dust">Click to open</div>
            )}
            <div className={`mt-3 ${open ? 'block' : 'hidden'}`}>
              <div className="flex flex-row mb-1 p-3 border-solid border-y-2 border-black">
                <div className="w-1/6 text-md font-medium">TEST ID</div>
                <div className="w-5/6 text-md font-medium">Notes</div>
              </div>
              {log &&
                log
                  .sort((a: LogInterface, b: LogInterface) =>
                    a.test_id.localeCompare(b.test_id),
                  )
                  .map((item: LogInterface) => (
                    <div
                      key={item.test_id}
                      className="flex flex-row mb-1 p-3 border-solid border-b-[1px] border-black"
                    >
                      <div className="w-1/6 text-sm">{item.test_id}</div>
                      <div className="w-5/6 text-sm">{item.notes}</div>
                    </div>
                  ))}
            </div>
          </div>
        }
      />
    );
  };

  return (
    <Container className="h-full py-4">
      {canSeeLog && (
        <>
          <div className="text-xxl font-black">Bugfix Log</div>
          <div className="text-sm text-neutral-dust">
            Will remove when we ready to deploy in production
          </div>
          {changelog &&
            changelog.map((log: ChangelogInterface) =>
              LogCard(log.date, log.log),
            )}
        </>
      )}
    </Container>
  );
};

export default ChangeLog;
